import { DrawingToolHelpers } from "../../helpers/drawing-tool-helpers";
import { IComponent } from "../component.interface";
import { IDrawingTool } from "./drawing-tool.interface";
import { DrawingToolsManager } from "./drawing-tools.manager";

export class HorizontalLineComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): HorizontalLineComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            drawingToolManager);

        const component = new HorizontalLineComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): HorizontalLineComponent {
        const component = new HorizontalLineComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {
        if (!annotationOptions?.typeOptions?.points?.length) {
            return;
        }

        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            this.drawingToolManager);

        this.annotation.update(annotationOptions);
        this.drawingToolManager.updateAnnotationStyles(this.annotation, annotationOptions, false);
    }

    public getMetaData(): any {
        if (!this.annotation.options?.typeOptions?.points?.length) {
            return null;
        }

        const startPoint = this.annotation.options.typeOptions.points[0];
        const actualStartPosition = DrawingToolHelpers.getActualStartTimePosition(startPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "horizontalLine",
            type: 'infinityLine', // options type
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                type: "horizontalLine", // typeOptions type
                
                line: {
                    stroke: this.annotation.options.typeOptions.line.stroke,
                    fill: this.annotation.options.typeOptions.line.fill,
                    strokeWidth: this.annotation.options.typeOptions.line.strokeWidth
                },
                points: [{
                    x: startPoint.x,
                    actualStartTimeT: actualStartPosition?.actualStartTimeT,
                    actualXValue: actualStartPosition?.actualXValue,

                    y: startPoint.y,
                }]
            }
        };
    }
}